import { useEffect } from 'react';

const NEW_DESIGN_THEME = 'new-design';

/**
 * Keeps data-theme="new-design" on <html> while the flag is on.
 *
 * applyDocumentTheme stamps the attribute before React mounts (avoids a FOUC).
 * This hook re-asserts it after mount and for the life of the tree — which
 * matters when an extension (e.g. Loom) mutates <html> during screen share and
 * would otherwise leave the page on the bare :root blue palette.
 */
export const useNewGuestLandingDocumentTheme = (isEnabled: boolean) => {
  useEffect(() => {
    if (!isEnabled) {
      return undefined;
    }

    const root = document.documentElement;
    const previousTheme = root.getAttribute('data-theme');
    root.setAttribute('data-theme', NEW_DESIGN_THEME);

    return () => {
      if (previousTheme && previousTheme !== NEW_DESIGN_THEME) {
        root.setAttribute('data-theme', previousTheme);
        return;
      }

      // Leave the attribute in place when it came from applyDocumentTheme (or
      // was already new-design). Root does not unmount in normal use; clearing
      // here would flash the old palette during Strict Mode remounts.
      if (previousTheme === NEW_DESIGN_THEME) {
        return;
      }

      root.removeAttribute('data-theme');
    };
  }, [isEnabled]);
};
